import { Drop_USP } from '@aboutyou/legacy-shared/src/grpc_client/grips/protos/shared/drop'
import Pill from '@aboutyou/legacy-shared/src/ui/Drops/components/Pill/Pill'
import { exists } from 'helpers/exists'
import React, { FC } from 'react'
import styled from 'styled-components'

export const DropDetailsUsps: FC<{ usps: Drop_USP[] | undefined }> = ({
  usps,
}) => {
  if (!exists(usps) || usps.length === 0) {
    return null
  }

  return (
    <StyledUSPContainer>
      {usps.map(({ text }) => (
        <Pill type="usp" key={text}>
          {text}
        </Pill>
      ))}
    </StyledUSPContainer>
  )
}

const StyledUSPContainer = styled.div`
  position: absolute;
  bottom: 30px;
  right: 60px;
  text-align: center;

  ${Pill} {
    &:last-of-type {
      margin-right: 0;
    }
  }
`
